var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-2"},[(_vm.value)?_c('font-awesome-icon',{attrs:{"icon":"star","color":"#f2b01e"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }